import { themeGet } from '@styled-system/theme-get';
import styled from 'styled-components';

import Card from '../../../../shared/Card';
import {
  Th,
  TableIcon,
  ThContentWrapper,
} from '../../../../shared/TableComponents/StyledComponents';

export const StyledCard = styled(Card)`
  margin: 0;
`;

export const TableSection = styled.div`
  padding: 1px 24px 5px;
`;

export const Td = styled.td`
  padding: 12px 0;
  border-top: 1px solid ${themeGet('colors.black.10')};
  border-bottom: none !important;
  color: ${themeGet('colors.black.100')};
  font-size: 12px;

  &:last-child {
    padding-right: 16px;
  }
  &:first-child {
    padding-left: 16px;
  }
`;

export const TdRight = styled(Td)`
  text-align: right;
`;

export const ColumnTitle = styled.p`
  padding: 0 0 0 8px;
  margin: 0;
`;

export const ThContentRight = styled(ThContentWrapper)`
  justify-content: flex-end;
  align-items: center;
  padding-right: 24px;
  cursor: default;

  &:last-child {
    padding-right: 0;
  }
`;

export const StyledTh = styled(Th)`
  padding-bottom: 12px;

  &:first-child {
    padding-left: 16px;
    padding-bottom: 12px;
  }
  &:last-child {
    padding-right: 16px;
  }
`;

export const TileTd = styled(Td)`
  display: flex;
  align-items: center;
  padding-right: 24px;
`;

export const TileImage = styled(TableIcon)`
  margin: 0 8px 0 0;
  border-radius: 4px;
`;

export const Placeholder = styled.div`
  padding: 24px;
`;

export const HeadlineLink = styled.a`
  font-weight: 400;
  font-size: 12px;
  color: ${themeGet('colors.primary.100')};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;
